const WORDS = ["مو", "رنگ و بالیاژ", "پوست", "فیشیال", "ناخن", "آرایش", "مژه", "عروس", "شینیون"];

export default function Ticker() {
  return (
    <div className="ticker" aria-hidden="true">
      {[0, 1].map((copy) => (
        <div className="ticker__track" key={copy}>
          {WORDS.map((w) => (
            <span className="ticker__item" key={`${copy}-${w}`}>
              {w}
              <span className="ticker__star">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  );
}
